module.exports = __webpack_public_path__ + "static/img/master-4.0013a327.png";